<template>
  <div class="Nosotros">
    <div class="banner">
      <div class="banner-box">
        <div class="tag">AVISO DE PRIVACIDAD</div>
        <img src="@/assets/imgs/img32.png" class="img32" />
      </div>
    </div>
    <div class="content">
      <div class="description margin-b32">
        En virtud de lo dispuesto por la Ley Federal de Protección de Datos
        Personales en Posesión de Particulares (LFPDPPP), su Reglamento, los
        Lineamientos del Aviso de Privacidad y las demás Disposiciones
        aplicables (en adelante denominados conjuntamente como la “Ley”), se
        emite el presente Aviso de Privacidad en los siguientes términos:
      </div>
      <div class="paragraph margin-b8">
        A. RESPONSABLE DE LOS DATOS PERSONALES.
      </div>
      <div class="description margin-b32">
        Para efectos del presente Aviso de Privacidad, Aguila Information,
        S.A.P.I. de C.V.. (en adelante el “Responsable” o “Paay Prima”,
        indistintamente), con domicilio en Insurgentes Sur 1248 Int. 498, Tlacoquemecatl, Benito Juárez, CDMX 03200 es el responsable en los
        términos de la Ley de la obtención, divulgación, almacenamiento y/o
        uso, incluido acceso, manejo, aprovechamiento, transferencia o
        disposición (en adelante el “Tratamiento”) de tus datos personales que
        recabe y, en general, de todos los datos personales que recabamos de
        nuestros clientes y usuarios (en adelante el(los) “Titular(es)”).
      </div>

      <div class="paragraph margin-b8">
        B. DATOS PERSONALES RECABADOS Y SOMETIDOS A TRATAMIENTO.
      </div>
      <div class="description margin-b32">
        <div>
          Conforme a lo anterior, te informamos que Paay Prima obtendrá tus
          datos personales, ya sea de forma directa o indirecta, cuando
          realizas una solicitud y proporcionas tus datos personales para
          efectos de la prestación de los servicios de crédito que ofrece Paay
          Prima, a través de nuestra página de Internet o aplicación nativa
          Android y/o IOS (“App”), vía telefónica, a través de un tercero o
          cualquier otro medio personal o electrónico.
        </div>
        <div>
          Almacenamiento de datos, Respecto a toda la información recopilada,
          la almacenaremos en el servidor de Paay Prima
          https://loan.paay.mx con un alto nivel de protección,y no se
          compartirá con ningún tercero.
        </div>
        <div>
          In the case of Credit applicants and/or debtors : Identification
          data, including your personal image;Authentication data, including
          biomet ric information;Contact information;Location data;Geolocation
          data;Financial data;Labor data;Academic data;Data derived from your
          use or utilization of the Platform.
        </div>
        <div>Permisos que le solicitamos.</div>
        <div>
          Le rogamos que lea atentamente lo siguiente para comprender nuestras
          opiniones y prácticas en relación con sus datos personales y cómo
          los trataremos.
        </div>
        <br>
        <div class="font-weight">1. Tu Ubicación y Nuestros Servicios.</div>
        <div>
          <p>Para que tu solicitud de préstamo sea más sencilla y ofrecerte servicios personalizados, necesitamos conocer tu ubicación aproximada.</p>
          <p>Solo recopilamos estos datos mientras usas nuestra aplicación (cuando está abierta y en primer plano) y los usamos para completar automáticamente la información de tu dirección. Una vez que sales de la aplicación o la pones en segundo plano, dejamos de recopilar tu ubicación.</p>
          <p>Si en algún momento no quieres compartir tu ubicación, puedes desactivar esta opción en la configuración de tu dispositivo.</p>
        </div>
        <br>
        <div class="font-weight">2. Permiso de Cámara</div>
        <div>
          <p>Para agilizar tu proceso de verificación, necesitamos acceso a la cámara de tu dispositivo. Con tu permiso, podrás tomar y subir directamente fotos de tu INE y de tu rostro. Esto es esencial para completar el proceso de verificación KYC (Conoce a tu Cliente).</p>
          <p>Queremos asegurarte que solo usaremos la cámara para este fin específico. No accederemos ni almacenaremos ninguna otra foto o video de tu galería.</p>
          <p>Si decides no darnos permiso para usar la cámara, no podrás subir las fotos necesarias para tu verificación y, por lo tanto, no podremos ofrecerte el servicio.</p>
        </div>
        <br>
        <!-- <div class="font-weight">3. Notificaciones Push</div>
        <div>
          <p>Para mantenerte al tanto de información importante, recordatorios y actualizaciones, necesitamos tu permiso para enviarte notificaciones.</p>
          <p>Tú tienes el control total: puedes activar o desactivar estas notificaciones en cualquier momento. Si decides no recibirlas, no afectará el resto de las funciones de la aplicación; podrás seguir usándolas normalmente.</p>
        </div>
        <br> -->
        <div class="font-weight">3. Permiso de Notificaciones</div>
        <div>
          <p>Se utiliza para enviarte notificaciones relacionadas con tu crédito, como actualizaciones del estado de la solicitud, confirmación del desembolso, recordatorios de pago y avisos importantes del servicio. Estas notificaciones tienen como objetivo ayudarte a gestionar tu préstamo de forma oportuna y segura.</p>
          <p>Se activa cuando hay cambios relevantes en el estado de tu solicitud o préstamo, o cuando es necesario enviarte recordatorios importantes relacionados con tu cuenta.</p>
          <p>Puedes administrar este permiso en la configuración de tu dispositivo.</p>
          <p>Android: Configuración > Aplicaciones > Paay Prima > Notificaciones</p>
          <p>iOS: Actualmente, la aplicación no solicita este permiso en dispositivos iOS. </p>
        </div>
        <br>
        <div class="font-weight">4. Referencias</div>
        <div>
          <p>Para verificar tu identidad, evaluar tu situación crediticia, analizar riesgos y prevenir fraudes, solo necesitamos la información de dos contactos de emergencia: su relación contigo, su nombre y su número de teléfono.</p>

          <p>Tienes una forma eficiente de proporcionarnos esta información:
            Autocompletar desde tu libreta de direcciones: Puedes seleccionar y subir rápidamente los contactos específicos que elijas. Así te ahorras el tiempo de escribirlos. Queremos que sepas que solo accederemos a los contactos que tú selecciones, no a toda tu libreta de direcciones.
          </p>

          <p>Nos comprometemos a nunca compartir tus datos con terceros sin tu autorización. Toda la información que nos proporciones se cargará y almacenará de forma segura en nuestros servidores, utilizando una conexión protegida (https).</p>
        </div>
        <!-- <div class="font-weight">5.SMS (FINANCIEROS)</div>
        <div>
          Recopilaremos y filtramos los mensajes SMS financieros que recibe, incluyendo el remitente, la fecha de recepción y el contenido. Estos datos se utilizarán para modelar riesgos con el fin de evaluar su situación crediticia, así como para prevenir fraudes y proteger su cuenta y fondos.  
        </div>
        <div>Sus datos serán transmitidos y almacenados de forma segura mediante cifrado a través de [https://loan.paayplus.mx]. Eliminaremos aquellos datos no relacionados con el análisis de riesgo financiero y, sin su permiso, nunca compartiremos esta información con terceros.  
Puede desactivar o activar este permiso en cualquier momento en la configuración del sistema. Si necesita eliminar los datos históricos autorizados, puede contactarnos en cualquier momento mediante correo electrónico. 
        </div>
        <div class="font-weight">6.APLICACIONES INSTALADAS (FINANCIEROS)</div>
        <div>
          Con el objetivo de prevenir fraudes, la aplicación solo obtendrá información relacionada con las aplicaciones financieras instaladas en su dispositivo, como el nombre de la aplicación, la fecha de instalación, la fecha de actualización y el número de versión. Esta información se transmitirá y almacenará de forma segura mediante cifrado a través de [https://loan.paayplus.mx], lo que nos ayuda a analizar mejor los riesgos de conducta y garantizar la seguridad de su cuenta y fondos.  
        </div>
        <div>
          Comprometemos que toda la información recopilada y los datos personales se someten a un tratamiento de cifrado riguroso y no se utilizarán para ningún otro propósito sin autorización, ni se compartirán con terceros. Puede administrar este permiso en la configuración del sistema en cualquier momento.
        </div> -->
        <br>
        <div class="font-weight">5. Acceso a tus SMS (Mensajes de Texto)</div>
        <div>
          <p>Para poder evaluar tu situación crediticia, analizar riesgos y protegerte contra fraudes,  necesitamos acceder y analizar los SMS de carácter financiero que recibas. Esto incluye el remitente, la hora de recepción y el contenido del mensaje.</p>

          <p>Es importante que sepas que tus datos se transmiten y almacenan de forma segura y cifrada en nuestro servidor (https://loan.paay.mx). Además, eliminaremos cualquier contenido de SMS que no esté relacionado con el análisis de riesgo financiero, y nunca compartiremos esta información con terceros sin tu autorización.</p>

          <p>Tienes la opción de activar o desactivar este permiso en cualquier momento desde la configuración de tu dispositivo. Si en algún momento decides que quieres que eliminemos los datos históricos que nos autorizaste a recopilar, solo tienes que contactarnos por correo electrónico y nosotros nos encargaremos de ello.</p>
        </div>
        <br>
        <div class="font-weight">6. Aplicaciones Instaladas</div>
        <div>
          <p>Para prevenir fraudes, sólo recopilamos información sobre las aplicaciones financieras instaladas en tu dispositivo. Esto incluye el nombre, la fecha de instalación, la fecha de actualización y el número de versión de esas aplicaciones.</p>

          <p>Esta información se envía y se almacena de forma segura y cifrada en nuestro servidor (https://loan.paay.mx). Nos ayuda a analizar los riesgos relacionados con el comportamiento del usuario y a proteger tanto tu cuenta como tu dinero.</p>

          <p>Queremos reiterar que toda tu información y datos personales se mantendrán estrictamente cifrados. Nunca los usaremos para otros fines ni los compartiremos con terceros sin tu permiso.</p>
        </div>
        <br>
        <div class="font-weight">7. Permisos del Estado del Teléfono</div>
        <div>
          Para evaluar el riesgo crediticio, con tu permiso, recopilaremos información sobre tu dispositivo móvil. Esto incluye el modelo, ID, dirección IP, dirección MAC, versión de hardware, versión del sistema, información de memoria y el estado operativo.
        </div>
        <br>
        <div class="font-weight">8. Permiso de Acceso al Estado de WiFi</div>
        <div>
          Con tu permiso, Paay podrá obtener la dirección WiFi de tu dispositivo. Usamos esta información para evaluar riesgos y detectar posibles problemas o actividades inusuales en la red.
        </div>
        <br>
        <div class="font-weight">9. Permiso de Acceso al Estado de la Red</div>
        <div>
          
          <p>Con tu permiso, Paay puede obtener información de tu conexión a internet, como la dirección de red, el estado y el tipo de conexión.</p>

          <p>Esto nos ayuda a asegurar que no haya interrupciones que puedan causar pérdida de datos o retrasos. Además, usamos esta información para evaluar riesgos y detectar cualquier actividad inusual en la red.</p>
        </div>
        <br>
        <div class="font-weight">10. Permiso de ID de Publicidad (AD_ID)</div>
        <div>
          Para analizar nuestros datos de publicidad y mejorar tu experiencia, Paay obtendrá tu ID de Publicidad de Google (GAID). Si prefieres desactivar este permiso, puedes hacerlo en cualquier momento deshabilitando la opción de "Publicidad personalizada" en la configuración de tu dispositivo.
        </div>
      </div>

      <div class="paragraph margin-b8">
        C. OPCIONES Y MEDIOS QUE Paay Prima, OFRECE A LOS TITULARES DE DATOS
        PERSONALES PARA LIMITAR EL USO O DIVULGACIÓN DE SUS DATOS PERSONALES.
      </div>

      <div class="description margin-b32">
        <div>
          I. El uso, siguiendo las instrucciones indicadas en el último
          párrafo del apartado C.
        </div>
        <div>
          II. La divulgación, siguiendo las instrucciones indicadas en el
          apartado G.
        </div>
        <div>
          III. Dirigiendo la solicitud correspondiente al área de Legal y
          Compliance para ejercer tus derechos ARCO conforme a los
          lineamientos establecidos en el apartado F.
        </div>
        <div>
          IV. En el caso de los datos personales recabados conforme al último
          párrafo del apartado E siguiente, podrás limitar su tratamiento
          conforme a lo ahí descrito. Asimismo, te recordamos que puedes
          acudir al Registro Público de Usuarios de la CONDUSEF (REUS) y
          registrarte para limitar el uso de tus datos personales para fines
          de publicidad y promoción por parte de cualquier Entidad Financiera.
          Para mayor información, puedes visitar la siguiente página web
          https://webapps.condusef.gob.mx/reus/ReusDW4/index.html.
        </div>
      </div>

      <div class="paragraph margin-b8">
        D. FINALIDADES A LAS QUE SE SUJETARÁ EL TRATAMIENTO DE DATOS
        PERSONALES.
      </div>
      <div class="description">
        <div>
          Paay Prima hace uso de tus datos personales conforme a los siguientes
          fines:
        </div>
        <div style="font-weight: bold">
          a) Finalidades originarias y necesarias para la prestación del
          servicio.
        </div>

        <div>
          1.Identificación del solicitante y/o cliente, según sea el caso.
        </div>
        <div>
          2.Integración del expediente de información de nuestro cliente.
        </div>
        <div>
          3.Gestión, control, administración y procesamiento de la solicitud
          de crédito y, en su caso, el otorgamiento de este.
        </div>
        <div>
          4.Gestión, control, administración, ejecución y cumplimiento del
          contrato de crédito celebrado con el cliente conforme a la solicitud
          correspondiente.
        </div>
        <div>
          5.Gestión, control y administración de la cobranza administrativa (a
          través de cualquier medio de contacto otorgado en la solicitud),
          extrajudicial y, en su caso, judicial derivada de los servicios
          proporcionados por Paay Prima.
        </div>
        <div>
          6.Investigación de cambios en perfil transaccional del cliente.
        </div>
        <div>
          7.Cumplimiento a obligaciones de carácter fiscal o comercial.
        </div>
        <div>
          8.Atención de consultas, dudas, aclaraciones o quejas del cliente.
        </div>
        <div>9.Estadística y registro histórico de usuarios y clientes.</div>
        <div>
          10.Creación, mantenimiento y entrenamiento de los modelos de riesgo
          predictivos de Paay Prima.
        </div>
        <div>
          11.Mantener la seguridad de la información y de la operación.
        </div>
        <div>12.Protección ante casos de robo de identidad.</div>

        <div style="font-weight: bold">b) Finalidades secundarias.</div>
        <div>
          1.Fines mercadotécnicos, publicitarios y/o de prospección comercial.
        </div>
        <div>
          2.Otorgamiento de estímulos o reconocimientos a clientes, cuando
          participen en nuestras campañas publicitarias, mercadológicas o
          comerciales.
        </div>
        <div>
          3.Mejoras en el servicio de atención y trato con el cliente.
        </div>
        <div>
          En caso de que no desees que se utilicen tus datos para estos fines
          adicionales por favor selecciona la siguiente casilla:
        </div>
      </div>
      <div class="description margin-b32">
        No deseo que mis datos sean utilizados para las finalidades
        secundarias descritas anteriormente. Recuerda que puedes solicitar la
        revocación de tu consentimiento en cualquier momento ingresando
        nuevamente a este aviso de privacidad y seleccionando la casilla
        correspondiente, en caso de que nos lo hayas otorgado previamente.
        Dicha solicitud aplica desde el momento que selecciones la casilla.
        Para que tu revocación sea guardada correctamente, deberás iniciar
        sesión en la página de https://www.paay.mx/ y seguir el
        procedimiento descrito previamente. La negativa para el uso de tus
        datos personales para estas finalidades no será motivo para negarte el
        servicio.
      </div>
      <div class="paragraph margin-b8">
        E. TRANSFERENCIA DE DATOS PERSONALES.
      </div>
      <div class="description">
        Paay Prima podrá realizar la transferencia y/o remisión de datos a:
      </div>
      <div class="c-table">
        <div class="row row-1">
          <span class="lei1"
            >Paay Prima puede transferir tus datos personales a:</span
          >
          <span class="lei2">Razones</span>
          <span class="lei3"
            >¿Puedes limitar ocancelar la transferencia de tusdatos?</span
          >
        </div>
        <div class="row">
          <span class="lei1"
            >Sociedades controladoras,subsidiarias oafiliadas a Paay Prima o a
            una sociedad matriz</span
          >
          <span class="lei2"
            >Resquardo,control,análisis estadistico,evaluaciÃón, mejora y
            diseno de nuevos productos.</span
          >
          <span class="lei3">No</span>
        </div>
        <div class="row">
          <span class="lei1"
            >Terceros no afiliados(prestadores deservicios)</span
          >
          <span class="lei2"
            >Asistencia en la eiecución de los servicios relacionados con tu
            credito.</span
          >
          <span class="lei3">No</span>
        </div>
        <div class="row">
          <span class="lei1"
            >Autoridades administrativas,iudiciales ogubernamentales, asi como
            a Sociedades deInformación Crediticia</span
          >
          <span class="lei2"
            >Por mandato judicial o administrativo o cuando una ley lo
            determine</span
          >
          <span class="lei3">No</span>
        </div>
        <div class="row">
          <span class="lei1">Terceros subcontratados</span>
          <span class="lei2"
            >Procesar información por cuenta de Paay Prima ybaio instrucciones
            de este.</span
          >
          <span class="lei3">No</span>
        </div>
        <div class="row">
          <span class="lei1"
            >Proveedores de maneio de riesgo,sequridadde la información y/o
            software especializado.</span
          >
          <span class="lei2">Para la prevención de fraude.</span>
          <span class="lei3">No</span>
        </div>
        <div class="row">
          <span class="lei1">Socios comerciales</span>
          <span class="lei2"
            >Para la adquisición de productos o serviciosobtenidos a través de
            créditos Paay Prima.</span
          >
          <span class="lei3">No</span>
        </div>
        <div class="row" style="border-bottom: none">
          <span class="lei1">Afiliados comerciales*</span>
          <span class="lei2">Fines publicitarios.</span>
          <span class="lei3">Sí</span>
        </div>
      </div>
      <div class="description margin-b32">
        <div>
          Los terceros y las entidades receptoras de datos personales, asumen
          las mismas obligaciones y/o responsabilidades de Paay Prima, de
          conformidad con lo descrito en el presente Aviso de Privacidad.
        </div>
        <div>
          Te informamos que tus datos personales podrán ser transferidos y
          tratados por personas distintas a Paay Prima, en México o en el
          extranjero cuando se trate de: a) Cualquier prospecto, comprador
          potencial o adquirente de Paay Prima o de cualesquiera de sus
          activos, incluyendo su cartera de crédito, otorgarle financiamiento,
          adquirir las acciones o activos de Paay Prima o sus accionistas o
          filiales en México; b) Cualquier autoridad o auditor interno y
          externo cuando así lo requieran para llevar a cabo la auditoría
          correspondiente; c) Cualquier proveedor o prestador de servicios de
          cobranza, análisis de riesgo crediticio y otros que Paay Prima
          considere necesario contratar.
        </div>
        <div>
          Para la transferencia indicada con asterisco (*) requerimos tu
          consentimiento, el cual nos estás otorgando al aceptar este aviso de
          privacidad. En caso de que no desees que tus datos sean transferidos
          a afiliados comerciales, por favor selecciona la siguiente casilla:
          [ ] No deseo que mis datos sean transferidos para fines
          publicitarios.
        </div>
        <div>
          Recuerda que puedes solicitar la revocación de tu consentimiento en
          cualquier momento ingresando nuevamente a este aviso de privacidad y
          seleccionando la casilla anterior en caso de que nos lo hayas
          otorgado previamente. Dicha solicitud aplica desde el momento que
          selecciones la casilla. Para que tu revocación sea guardada
          correctamente, deberás iniciar sesión en la página de
          https://www.paay.mx/ y seguir el procedimiento descrito
          previamente. La negativa respecto a la transferencia de tus datos
          personales para estas finalidades no será motivo para negarte el
          servicio.
        </div>
        <div>
          Asimismo, hacemos de tu conocimiento que podremos transferir tus
          datos sin necesidad de tu autorización previa en cualquiera de los
          supuestos considerado en el artículo 37 de la LFPDPPP.
        </div>
      </div>
      <div class="paragraph margin-b8">F. Derechos ARCO.</div>
      <div class="description margin-b32">
        <div>
          Todos sus datos personales son tratados de conformidad con la
          legislación aplicable vigente en el país, por lo que le informamos
          que usted tiene derecho (ARCO) de acceder, rectificar, cancelar u
          oponerse a que tratemos sus datos personales en cualquier momento.
          De conformidad con la Ley de Privacidad del Consumidor Usted tiene
          derecho a saber si sus datos personales están siendo vendidos y
          otros derechos de privacidad. Tiene los siguientes derechos：
        </div>
        <div>
          Derecho a ser informado: tiene derecho a conocer el tipo y el
          contenido específico de los datos personales que recopilamos y si
          sus datos personales se venden a terceros. Podrá informarse sobre
          nuestro tratamiento de los datos personales en este acuerdo. Derecho
          de acceso: tiene derecho a acceder a la información personal que
          tenemos sobre usted. Derecho de supresión: puede solicitar la
          supresión de la información personal que hayamos recopilado sobre
          usted, a menos que la ley nos obligue a conservarla. Consulte la
          sección H «Supresión» para obtener más información sobre cómo
          hacerlo. Derecho a oponerse a la venta: Si vendemos su información
          personal, tiene derecho a oponerse a la venta. Si desea ejercer
          estos derechos o tiene alguna pregunta sobre sus derechos de
          privacidad, no dude en ponerse en contacto con nosotros en
          servicio@paay.mx.
        </div>
      </div>
      <div class="paragraph margin-b8">
        G. OTROS MEDIOS PARA RECABAR DATOS PERSONALES.
      </div>
      <div class="description margin-b32">
        Paay Prima utiliza cookies y/o web beacons para facilitar la navegación
        en el sitio web https://www.paay.mx/. Las cookies constituyen una
        herramienta empleada por los servidores web para almacenar y recuperar
        información que se guarda en el navegador utilizado por los usuarios o
        visitantes del sitio web, lo que permite guardar tus preferencias
        personales para brindarte una mejor experiencia de navegación. Las
        cookies tienen fecha de caducidad, que puede oscilar desde el tiempo
        que dura la sesión o visita al sitio web hasta una fecha específica a
        partir de la cual dejan de ser operativas. Las cookies empleadas en
        https://www.paay.mx/ se asocian únicamente con un Usuario anónimo
        y su equipo informático, no proporcionan referencias que permitan
        deducir el nombre y apellidos del Usuario, no pueden leer datos de su
        disco duro ni incluir virus en sus textos. Puedes configurar tu
        navegador para aceptar o rechazar automáticamente todas las cookies o
        para recibir un aviso en pantalla sobre la recepción de cada cookie y
        decidir en ese momento su implantación o no en tu disco duro. Te
        sugerimos consultar la sección de ayuda de tu navegador para saber
        cómo cambiar la configuración sobre aceptación o rechazo de cookies.
        Aún y cuando configures tu navegador para rechazar todas las cookies o
        rechaces expresamente las cookies de https://www.paay.mx/ podrás
        seguir navegando por el sitio web con el único inconveniente de no
        poder disfrutar de las funcionalidades del sitio que requieran la
        instalación de alguna de ellas. En todo caso, podrás eliminar las
        cookies de https://www.paay.mx/ instaladas en tu disco duro, en
        cualquier momento, siguiendo el procedimiento establecido en la
        sección de ayuda de tu navegador. Te confirmamos que Paay Prima no
        recaba datos personales a través de estos medios, por lo que no se
        someten a tratamiento ni a transferencias. Asimismo, recabamos
        información a partir de las autorizaciones que nos otorgas cuando
        ingresas a tu usuario a través de nuestra App, o a tu calendario,
        contactos y/o ubicación con la única finalidad establecida en el punto
        10 de las finalidades originarias establecidas en el apartado C de
        este aviso de privacidad que se refiere a la creación, mantenimiento y
        entrenamiento de los modelos de riesgo predictivos de Paay Prima. Es de
        suma importancia para Paay Prima informarte que nunca utilizaremos la
        información recabada por estos medios de manera individual ni para
        algún uso distinto al descrito. Paay Prima no puede revocar dichas
        autorizaciones ya que esto debe modificarse desde el teléfono móvil
        desde el cual fueron otorgadas; por lo que tú puedes revocar en
        cualquier momento dichas autorizaciones ingresando a la configuración
        de tu teléfono móvil. Es importante que sepas que, en todo momento
        puedes comunicarte con nosotros a través de los medios de contacto que
        ponemos a tu disposición en el sitio web https://www.paay.mx/ y
        con gusto te brindaremos asesoría sobre el procedimiento para revocar
        dichos consentimientos desde tu dispositivo.
      </div>
      <div class="paragraph margin-b8">
        H. Conservación y supresión de datos personales
      </div>
      <div class="description margin-b32">
        <div style="font-weight: bold">Almacenamiento</div>
        <div>
          Paay Prima recopilará, almacenará y controlará los datos personales y
          los cargará en https://loan.paay.mx. Utilizamos esta información
          para evaluar su solvencia y evitar fraudes en los préstamos. Paay
          Prima nunca compartirá datos con terceros sin su permiso. Sólo
          recopilaremos esta información si usted nos ha dado su
          consentimiento. Los datos se transferirán y cargarán a través de una
          conexión segura (https).
        </div>
        <div style="font-weight: bold">Supresión</div>
        <div>
          A) Si no solicita activamente la eliminación de sus datos
          personales, los datos recopilados se eliminarán automáticamente de
          forma masiva tras 6 meses de almacenamiento en una dirección segura.
        </div>
        <div>
          B) Cuando cancele su cuenta, todos los datos personales asociados a
          esa cuenta se borrarán al mismo tiempo. Encontrará el portal de
          cancelación de cuentas en el sitio web de Paay Prima.
        </div>
        <div>
          C) Solicitud de supresión de datos personales Si usted desea
          conservar su cuenta pero que algunos de sus datos personales sean
          borrados, por favor escriba a nuestro Equipo Legal y de Cumplimiento
          a Insurgentes Sur 1248 Int. 498, Tlacoquemecatl, Benito Juárez, CDMX 03200, anexando el formato Solicitud de Borrado de Datos
          Personales y copia de su identificación oficial. Paay Prima te
          comunicará, en un plazo máximo de veinte días hábiles, contados
          desde la fecha en que recibamos la solicitud correspondiente, la
          determinación adoptada. Si la solicitud resulta procedente, esta se
          hará efectiva dentro de los quince días hábiles siguientes a la
          fecha en que el Responsable comunique la respuesta. En caso de que
          la información proporcionada en tu solicitud sea errónea o
          insuficiente, o no se acompañen los documentos necesarios para
          acreditar tu identidad o la representación legal correspondiente, o
          cualquier otro que sea necesario para ejercer tus derechos; dentro
          de los cinco días hábiles siguientes a la recepción de tu solicitud,
          requeriremos la subsanación de las deficiencias para poder dar
          trámite a la misma. En estos casos, contarás con diez días hábiles
          para atender el requerimiento de subsanación, contados a partir del
          día siguiente en que lo hayas recibido. La solicitud correspondiente
          se tendrá por no presentada si no respondes dentro de dicho plazo.
          En el supuesto de que tuvieras un préstamo activo (vencido o por
          vencer) con nosotros, Paay Prima no podrá hacer modificaciones a tus
          datos personales. Para lograr esto, será necesario que primero
          pagues tu préstamo y una vez liquidado, sigas el proceso descrito
          anteriormente. Puede ponerse en contacto con nosotros llamando al
          +52 5564623367 o enviando un correo electrónico a
          servicio@paay.mx.
        </div>
        <div style="font-weight: bold">Denuncias reglamentarias</div>
        <div>
          Recuerda que en caso de insatisfacción o incumplimiento de parte
          nuestra, podrás acudir ante el Instituto Nacional de Transparencia,
          Acceso a la Información y Protección de Datos Personales (INAI) para
          solicitar el inicio del procedimiento de protección de derechos.
          Como titular, serás responsable de mantener actualizados tus datos
          personales en posesión de mexocin. Por lo anterior, nos garantizas y
          respondes en cualquier caso, de la veracidad, exactitud, vigencia y
          autenticidad de los datos personales facilitados, y te comprometes a
          mantenerlos debidamente actualizados, comunicando cualquier cambio
          al Responsable.
        </div>
      </div>
      <div class="paragraph margin-b8">I. REVOCACIÓN DEL CONSENTIMIENTO.</div>
      <div class="description margin-b32">
        En cualquier momento, podrás revocar tu consentimiento para el
        tratamiento de tus datos personales, siempre y cuando, dicha
        revocación sea legítima y no suponga la imposibilidad de cumplir
        obligaciones derivadas de una relación contractual vigente entre Paay
        Prima y tú, o no sea posible en virtud de un mandato legal o judicial.
        Puedes solicitar la revocación de tu consentimiento, iniciando sesión
        en https://www.paay.mx/ seleccionando las casillas deseadas. La
        negativa respecto al tratamiento de tus datos personales para estas
        finalidades y/o transferencias, no vulnerará tu relación contractual
        con Paay Prima.
      </div>
      <div class="paragraph margin-b8">
        J. CAMBIOS AL AVISO DE PRIVACIDAD.
      </div>
      <div class="description margin-b32">
        Cualquier actualización, modificación o cambio al presente aviso de
        privacidad, que se realice atendiendo a novedades legislativas y/o
        modificaciones en las políticas internas de Paay Prima, será publicado
        en el sitio web https://www.paay.mx/ Sin embargo, cuando el
        contenido del presente Aviso de Privacidad cambie sustancialmente; por
        ejemplo, si las finalidades para las cuales fueron recabados los datos
        personales cambiaran, te será informado y requeriremos nuevamente de
        tu consentimiento para continuar tratando tus datos personales.
      </div>
      <div class="paragraph margin-b8">K. POLÍTICAS DE SEGURIDAD.</div>
      <div class="description margin-b32">
        Paay Prima protege tus datos personales usando el estándar de la
        industria en materia de encriptación, de esta forma garantizamos que
        los datos que se envían desde la página de Internet lleguen seguros a
        nuestros servidores. Almacenamos y procesamos tu información
        manteniendo siempre medidas de seguridad orientadas a proteger tus
        datos personales. En Paay Prima contamos con procedimientos que dictan
        quién y bajo qué condiciones se puede tener acceso a los datos, dando
        siempre la máxima prioridad a la protección de tu privacidad.
        Asimismo, asumimos medidas de seguridad físicas para prevenir el
        acceso no autorizado a nuestros sistemas e instalaciones. Si tiene
        alguna pregunta sobre nuestra política de seguridad o tiene
        necesidades adicionales para la protección segura de sus datos
        personales, puede ponerse en contacto con nuestro responsable de
        protección de datos, Julian Forero Meade, en julian@paay.mx.
      </div>
      <div class="paragraph margin-b8">
        L. Base jurídica para el tratamiento de datos personales
      </div>
      <div class="description margin-b32">
        Tratamos sus datos personales con arreglo a las siguientes bases
        jurídicas: Cumplimiento de un contrato: Cuando celebra un contrato o
        acuerdo con nosotros, necesitamos tratar sus datos para cumplir
        nuestras obligaciones contractuales y prestar los servicios
        correspondientes. Interés legítimo: Basándonos en nuestros intereses
        comerciales legítimos, podemos tratar sus datos para garantizar el
        funcionamiento seguro y eficaz de nuestros servicios. En tales casos,
        siempre respetaremos sus derechos y salvaguardaremos nuestros
        intereses legítimos sin comprometer su privacidad. Consentimiento del
        usuario: En algunos casos le pediremos su consentimiento,
        especialmente cuando recopilemos o procesemos información sensible.
        Puede retirar su consentimiento en cualquier momento sin que ello
        afecte a la legalidad del tratamiento basado en el consentimiento
        previo a la retirada. Obligaciones Legales: Estamos obligados a
        cumplir con las leyes y reglamentos mexicanos y en algunos casos
        procesamos sus datos para cumplir con obligaciones legales, tales como
        requisitos fiscales, de auditoría u otros de cumplimiento obligatorio.
        De conformidad con la Ley Federal de Protección de Datos Personales y
        demás leyes aplicables en materia de privacidad en México, usted tiene
        derecho a acceder, rectificar y suprimir sus datos personales, así
        como a oponerse o limitar nuestras prácticas de tratamiento de datos.
        Si desea ejercer estos derechos o tiene alguna pregunta, póngase en
        contacto con nosotros en servicio@paay.mx.
      </div>
      <div class="paragraph margin-b8">M. CONSENTIMIENTO DEL TITULAR.</div>
      <div class="description margin-b32">
        Con la lectura y aceptación del presente Aviso de Privacidad cada vez
        que ingresas a tu perfil de usuario por cualquiera de los medios
        disponibles para ello, manifiestas expresamente que: (i) el presente
        Aviso de Privacidad te ha sido dado a conocer por Paay Prima y (ii) has
        leído y entendido en su totalidad los términos y alcances expuestos,
        por lo que expresamente otorgas tu consentimiento para el tratamiento
        de tus datos personales en los términos del mismo.
      </div>
      <div class="description margin-b32">
        Fecha de última actualización: 2025.04.08
      </div>
      <div class="description margin-b32">
        <div>Aguila Information, S.A.P.I. de C.V.</div>
        <div>
          Dirección: Insurgentes Sur 1248 Int. 498, Tlacoquemecatl, Benito Juárez, CDMX 03200
        </div>
        <div>Teléfono: +52 5564623367</div>
        <div>Correo electrónico: servicio@paay.mx</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Nosotros',
  components: {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
.banner {
  padding: 0 360px;
  margin-top: 70px;
  margin-bottom: 22px;
}
.banner-box {
  height: 84px;
  background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
  border-radius: 34px 34px 0px 0px;
  padding: 0 45px;
  display: flex;
  align-items: center;
  position: relative;
}
.img32 {
  position: absolute;
  width: 138px;
  height: 138px;
  bottom: 0;
  right: 22px;
}
.banner-box div {
  margin-right: 75px;
  font-size: 16px;
  color: #977f6a;
  cursor: pointer;
}
.tag {
  position: relative;
  color: #000000 !important;
  font-weight: bold;
}
.tag::after {
  content: ' ';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff4134;
  position: absolute;
  left: -18px;
  top: 8px;
}

.content {
  padding: 0 410px;
}

.description {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 16px;
}
.paragraph {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 16px;
}
.margin-b8 {
  margin-bottom: 8px;
}
.margin-b32 {
  margin-bottom: 32px;
}
.font-weight {
  font-weight: bold;
}
.c-table {
  border: 1px solid #979797;
  margin-bottom: 14px;
}
.row {
  height: 64px;
  border-bottom: 1px solid #979797;
  padding: 0 26px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.row span {
  display: flex;
  align-items: center;
}
.lei1 {
  width: 30%;
}
.lei2 {
  width: 40%;
}
.lei3 {
  width: 20%;
}
.row-1 {
  background: #fff8f2;
  font-weight: bold;
}

@media (max-width: 768px) {
  .content {
    padding: 0 140px;
  }
  .paragraph {
    font-size: 65px;
    line-height: 110px;
    margin: 50px 0;
  }
  .description {
    font-size: 65px;
    line-height: 120px;
  }

  .banner {
    padding: 0 140px;
  }
  .banner-box {
    height: 384px;
    background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
    border-radius: 34px 34px 0px 0px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .banner-box div {
    font-size: 65px;
    color: #977f6a;
    cursor: pointer;
    margin-right: 0;
    flex: 1;
    text-align: center;
  }
  .tag {
    margin-right: 0;
  }
  .tag::after {
    content: ' ';
    width: 0;
    height: 0;
  }
  .img32 {
    display: none;
  }
}
</style>
